import { render, staticRenderFns } from "./RoundIconButton.vue?vue&type=template&id=a7c60cd6&scoped=true"
import script from "./RoundIconButton.vue?vue&type=script&lang=ts"
export * from "./RoundIconButton.vue?vue&type=script&lang=ts"
import style0 from "./RoundIconButton.vue?vue&type=style&index=0&id=a7c60cd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7c60cd6",
  null
  
)

export default component.exports